import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { useGetTotalOfConfirmedDealsQuery } from "../../api/empresa/empresaApi";
import { useEffect, useState } from "react";
import { EventClickArg, EventInput } from "@fullcalendar/core/index.js";
import { parseConfirmedDealsToEvents } from "../../utils/calendarUtils";
import { ModalContainer } from "../UtilitiesComponents/ModalContainer";
import { ConfirmedDealsContainer } from "./CofirmedDealsContainer";

export function Calendario() {
    const [tasks, setTasks] = useState<EventInput>([])
    const [showModal, setShowModal] = useState(false);
    const [dateSelected, setDateSelected] = useState<string | null>(null);

    const { data: deals } = useGetTotalOfConfirmedDealsQuery(null, { refetchOnMountOrArgChange: true });

    useEffect(() => {
        setTasks(parseConfirmedDealsToEvents(deals ?? []));
    }, [deals])

    const handleClick = (dateInfo: DateClickArg) => {
        setShowModal(true);
        setDateSelected(dateInfo.dateStr);
    }

    const handleEventClick = (eventInfo: EventClickArg) => {
        setShowModal(true);
        setDateSelected(eventInfo.event.startStr);
    } 

    return (
        <>
            <FullCalendar
                plugins={[ dayGridPlugin, interactionPlugin ]}
                dateClick={handleClick}
                eventClick={handleEventClick}
                height={"90%"}
                aspectRatio={3}
                locale="es"
                headerToolbar={{ center: "dayGridYear,dayGridMonth,dayGridWeek,dayGridDay"}}
                initialView="dayGridMonth"
                events={tasks}/>

            {showModal && (
            <ModalContainer>
                <ConfirmedDealsContainer 
                    dateSelected={dateSelected!}
                    setShowModal={setShowModal}/>
            </ModalContainer>
            )}
        </>

    )
}